import React from 'react'
import moment from 'moment'
import { formatDateTime } from '@cbgms/base/utils/datetime'

export const Date: React.FC<{ content: moment.MomentInput }> = ({ content }) => {
  return <>{formatDateTime(content)}</>
}

export default Date
